import React, { useState } from 'react';
import { Textarea, Label, ErrorText } from '../lib';

const TextAreaCollapse = React.forwardRef((props, ref) => {
    const { name, label, error, ...rest } = props;
    const [isOpened, setOpened] = useState(false);

    return (
        <div style={{ borderBottom: '1px solid #cacaca', padding: '5px 0', marginBottom: '10px', width: '100%' }}>
            <Label style={{cursor: 'pointer'}} onClick={() => setOpened(state => !state)} htmlFor={name}>{label}</Label>
            {isOpened && <Textarea name={name} ref={ref} style={{resize:'none'}} {...rest} />}
            {error && <ErrorText>{error}</ErrorText>}
        </div>
    )
});

export default TextAreaCollapse;